import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import queryString from 'query-string'
import { withNamespaces } from 'react-i18next'
import styled from 'styled-components'

import { changePassword } from '../../../ducks/auth'

import Preloader from '../../../components/UI/Preloader'

import FormInput from '../../../components/Forms/Input'
import Button from '../../../components/Forms/Button'

const StyledButtonsBar = styled.div`
  display: flex;
  flex-direction: column;
`

class ChangePasswordPage extends Component {
  state = {
    password: '',
    verifyPassword: ''
  }

  handleInput = (name) => (ev) => {
    this.setState({
      [name]: ev.target.value
    })
  }

  handleSubmit = (ev) => {
    ev.preventDefault()
    const { password, verifyPassword } = this.state

    const { key } = queryString.parse(this.props.location.search)
    if (!password || password !== verifyPassword) {
      return null
    }
    this.props.changePassword({ password, key })
  }

  render() {
    const { t } = this.props
    const { password, verifyPassword } = this.state
    const { loading } = this.props.auth.changePassword

    const errorMessage =
      password !== verifyPassword ? t('forms:passwordsDoNotMatch') : ''

    return (
      <React.Fragment>
        {loading && <Preloader />}
        <form onSubmit={this.handleSubmit}>
          <FormInput
            label={t('forms:password')}
            input={{
              onChange: this.handleInput('password'),
              value: password,
              name: 'password',
              type: 'password'
            }}
            meta={{
              error: errorMessage
            }}
          />
          <FormInput
            label={t('forms:confirmPassword')}
            input={{
              onChange: this.handleInput('verifyPassword'),
              value: verifyPassword,
              name: 'confirmPassword',
              type: 'password'
            }}
            meta={{
              error: errorMessage
            }}
          />
          <StyledButtonsBar>
            <Button
              disabled={loading || !password || password !== verifyPassword}
              type="submit"
            >
              {t('forms:updatePassword')}
            </Button>
            <Link to="/">
              <Button>{t('common:goBack')}</Button>
            </Link>
          </StyledButtonsBar>
        </form>
      </React.Fragment>
    )
  }
}

export default compose(
  connect(
    ({ auth }) => ({ auth }),
    { changePassword }
  ),
  withNamespaces()
)(ChangePasswordPage)
